module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关键词",
      "prop": "keyWord"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入关键词",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParams.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "keyWord", $$v)
      },
      expression: "queryParams.keyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleCurrentChange(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "用户(ID)",
      "min-width": "70",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.userInfo.nickname) + "(" + _vm._s(scope.row.userInfo.id) + ")")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "直播间ID",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "直播分类",
      "min-width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roomTitle",
      "label": "标题",
      "min-width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "frontImg",
      "label": "封面",
      "align": "center",
      "width": "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.frontImg) ? _c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "",
            "trigger": "click"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "500px"
          },
          attrs: {
            "src": scope.row.frontImg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px",
            "object-fit": "cover"
          },
          attrs: {
            "slot": "reference",
            "src": scope.row.frontImg
          },
          slot: "reference"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pkNum",
      "label": "pk次数",
      "min-width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fansNum",
      "label": "粉丝数",
      "min-width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "直播状态",
      "min-width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status === 1 ? '直播中' : scope.row.status === 3 ? '已封禁' : '已结束'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "min-width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.verifyStatus === 0 ? '审核中' : scope.row.verifyStatus === 1 ? '审核通过' : '审核拒绝'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.timestampFormat(scope.row.createTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "",
            "trigger": "click",
            "content": "",
            "width": "800"
          },
          on: {
            "show": function($event) {
              return _vm.handlezuanshiliushuitongji(scope.row.id)
            }
          }
        }, [(_vm.data) ? _c('div', {
          staticClass: "box"
        }, [_c('div', {
          staticClass: "box-item"
        }, [_c('span', {
          staticClass: "box-item-span1"
        }, [_vm._v("今日数据")]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间流水(花币)：" + _vm._s(_vm.data.toDayInfo.chatRoomSum))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("主播收入(积分)：" + _vm._s(_vm.data.toDayInfo.zbsr))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间开播时长(h)：" + _vm._s(_vm.data.toDayInfo.kbSc))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("送礼人数：" + _vm._s(_vm.data.toDayInfo.giveNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "box-item"
        }, [_c('span', {
          staticClass: "box-item-span1"
        }, [_vm._v("本周数据")]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间流水(花币)：" + _vm._s(_vm.data.currentWeekInfo.chatRoomSum))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("主播收入(积分)：" + _vm._s(_vm.data.currentWeekInfo.zbsr))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间开播时长(h)：" + _vm._s(_vm.data.currentWeekInfo.kbSc))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("送礼人数：" + _vm._s(_vm.data.currentWeekInfo.giveNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "box-item1"
        }, [_c('span', {
          staticClass: "box-item-span1"
        }, [_vm._v("本月数据")]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间流水(花币)：" + _vm._s(_vm.data.currentMonthInfo.chatRoomSum))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("主播收入(积分)：" + _vm._s(_vm.data.currentMonthInfo.zbsr))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间开播时长(h)：" + _vm._s(_vm.data.currentMonthInfo.kbSc))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("送礼人数：" + _vm._s(_vm.data.currentMonthInfo.giveNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "box-item1"
        }, [_c('span', {
          staticClass: "box-item-span1"
        }, [_vm._v("上月数据")]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间流水(花币)：" + _vm._s(_vm.data.lastMonthInfo.chatRoomSum))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("主播收入(积分)：" + _vm._s(_vm.data.lastMonthInfo.zbsr))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("房间开播时长(h)：" + _vm._s(_vm.data.lastMonthInfo.kbSc))]), _vm._v(" "), _c('span', {
          staticClass: "box-item-span"
        }, [_vm._v("送礼人数：" + _vm._s(_vm.data.lastMonthInfo.giveNumber))])])]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "size": "mini",
            "type": "text",
            "icon": "el-icon-view"
          },
          slot: "reference"
        }, [_vm._v("房间统计")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "prev, pager, next, jumper",
      "page-size": _vm.queryParams.size,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56134881"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/fangjiantongji.vue
// module id = 622
// module chunks = 1